function initializePostscriptPopup() {
      if (!window.postscript || typeof window.postscript !== "object" ||
          typeof window.postscript.popups?.open !== "function") {
          return; // Postscript SDK isn't fully ready
      }

      function attachClickEvent(link) {
          link.addEventListener("click", function(event) {
              event.preventDefault(); // Prevent default link behavior
              window.postscript.popups.open("e7813bdf-35f7-4ab5-a604-a94840d8f050", {
                  activePopupBehavior: 'ALWAYS_DISMISS',
                  respectPopupStatus: false
              });
          });
      }

      let link = document.getElementById("postscript-popup-link-en");

      if (link) {
          attachClickEvent(link);
      } else {
          // Wait for the link to be added to the DOM if it's not there yet
          const observer = new MutationObserver((mutations, obs) => {
              link = document.getElementById("postscript-popup-link-en");
              if (link) {
                  attachClickEvent(link);
                  obs.disconnect(); // Stop observing once link is found
              }
          });

          observer.observe(document.body, { childList: true, subtree: true });
      }
  }

  // Check if Postscript SDK is available
  if (window.postscript && typeof window.postscript === "object" &&
      typeof window.postscript.popups?.open === "function") {
      initializePostscriptPopup();
  } else {
      // Wait for Postscript to be ready
      window.addEventListener("postscriptReady", initializePostscriptPopup);
  }